'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lmagnolia1_CallByNeed(eval$1, supportDynamicValueEvaluation) {
  this.mg = null;
  this.A6 = null;
  this.Kl = null;
  this.Kk = null;
  this.Km = false;
  this.mg = eval$1;
  this.A6 = supportDynamicValueEvaluation;
  if ((!(!this.A6.h()))) {
    var res = new $j_java$002elang$002e$002dObject.$c_s_Some(this.mg);
    this.mg = null;
    var finalRes = res;
  } else {
    var finalRes = $j_java$002elang$002e$002dObject.$m_s_None$();
  }
  this.A6 = null;
  this.Kl = finalRes;
}
export { $c_Lmagnolia1_CallByNeed as $c_Lmagnolia1_CallByNeed };
$p = $c_Lmagnolia1_CallByNeed.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lmagnolia1_CallByNeed;
/** @constructor */
function $h_Lmagnolia1_CallByNeed() {
}
export { $h_Lmagnolia1_CallByNeed as $h_Lmagnolia1_CallByNeed };
$h_Lmagnolia1_CallByNeed.prototype = $p;
$p.lp = (function() {
  if ((!this.Km)) {
    if ((this.mg === null)) {
      var $x_1 = this.Kl.C().h();
    } else {
      var result = this.mg.h();
      this.mg = null;
      var $x_1 = result;
    }
    this.Kk = $x_1;
    this.Km = true;
  }
  return this.Kk;
});
var $d_Lmagnolia1_CallByNeed = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lmagnolia1_CallByNeed, "magnolia1.CallByNeed", ({
  nK: 1,
  a: 1
}));
export { $d_Lmagnolia1_CallByNeed as $d_Lmagnolia1_CallByNeed };
